import React from 'react';
import cx from 'classnames';
import css from 'src/styles/App.scss';

export const LOADING_DIALOG = 'LOADING_DIALOG';

const LoadingDialog = () => {
    return (
        <div className={css.loader}>
            <div className={css.cwLoading}>
                <div className={cx(css.cwLoadingSpinner, css.cwLoadingSpinnerChildOuter)}>
                    <div className={cx(css.cwLoadingSpinner, css.cwLoadingSpinnerChildInner)} />
                </div>
            </div>
        </div>
    );
};

export default LoadingDialog;
